/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOpenItemCollections.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/open-item-collections";

export class AutogenModelOpenItemCollections<RowType extends ModelRow> extends Endpoint<RowType, RowOpenItemCollectionsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOpenItemCollections extends ModelRow<RowOpenItemCollectionsFields> {
	constructor(values?: Partial<RowOpenItemCollectionsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOpenItemCollectionsFields {
	adjustments: number;
	amount: number;
	amount_billed: number;
	amount_paid: number;
	ar_reason_code_id: string;
	bill_date: Date;
	bill_due_days: number;
	customer_id: string;
	gl_date: Date;
	invoice_no_string: string;
	name: string;
	order_id: string;
	outstanding_balance: number;
	record_type: string;
	reference_number: string;
	remark: string;
}

